/**
 * Feature flags for temporarily enabling/disabling platform features.
 * Set to true to enable, false to disable.
 */
export const FEATURE_FLAGS = {
  /**
   * Gig discovery feature - search for gigs by city, view upcoming gigs, etc.
   * Temporarily disabled while we focus on building artist-created profiles.
   */
  GIGS_ENABLED: false,

  /**
   * Venue discovery feature - browse venues, view venue profiles with gig listings.
   */
  VENUES_ENABLED: false,
} as const;

/**
 * Message shown when gigs feature is accessed while disabled
 */
export const GIGS_DISABLED_MESSAGE = 
  "Gig discovery is temporarily disabled while we focus on improving artist profiles.";
